// Location: src/theme.js
// Date: 20240929
// Author: R Matthews
// Purpose: Define and export themes for the project based off of colour ramp from Fluent Design System.

import { createDarkTheme, createLightTheme } from '@fluentui/react-components';

export const rhemlabs = { 
  10: "#020401",
  20: "#111C0D",
  30: "#162F13",
  40: "#1A3D16",
  50: "#1C4B19",
  60: "#1F5A1C",
  70: "#20691E",
  80: "#227820",
  90: "#228822",
  100: "#2B982A",
  110: "#4DA445",
  120: "#69B15F",
  130: "#82BE78",
  140: "#9BCB91",
  150: "#B3D7AB",
  160: "#CBE4C5"
};

export const RHEMLight = createLightTheme(rhemlabs);
export const RHEMDark = createDarkTheme(rhemlabs);